// =====================================================
// ✅ Shopify Dawn対応：URLからJANを取得し、JANの8桁目だけを変更して画像を切り替える
//    🎯 特別ルール：「しらふじ」だけ index = 5 に固定
// =====================================================
document.addEventListener("DOMContentLoaded", () => {
  console.log("🟢 color-switch.js 読み込みOK");

  // 1️⃣ URLから13桁のJANコードを取得（例: /products/j3237105083833）
  const m = window.location.href.match(/j(\d{13})/);
  const jan = m ? m[1] : null;
  if (!jan) {
    console.warn("⚠️ JANコードがURLに見つかりません。URLに j＋13桁 が含まれているか確認してください。");
    return;
  }
  console.log("📦 JANコード:", jan);

  // 2️⃣ 色の順番を定義（順番が番号に対応）
  // 🎨 しらふじ だけ固定で index = 5
  const COLOR_HEX_ORDER = ['#c1e4e9','#dbd0e6','#f5b1aa','#edd3a1','#92b5a9','#dbd0e6','#cbb994','#c0c6c9'];
  const COLOR_NAME_ORDER = ['しらあい','しらふじ','さんご','うすき','ちぐさ','しらふじ','しろつるばみ','はいあお'];

  // 3️⃣ グローバル関数（HTMLのonclickから呼び出す）
  window.setColor = function (code, label, idxRaw) {
    try {
      // ---- 選択された色を画面に反映 ----
      const input = document.getElementById('color_code');
      const span  = document.getElementById('selected_color_label');
      if (input) input.value = `${code}（${label}）`;
      if (span)  span.innerText = `${label}（${code}）`;

      // ---- index（番号）を安全に算出 ----
      let idx = Number(idxRaw);
      if (!Number.isInteger(idx)) {
        const posHex = COLOR_HEX_ORDER.indexOf(String(code).toLowerCase());
        if (posHex >= 0) idx = posHex;
        else {
          const posName = COLOR_NAME_ORDER.indexOf(String(label));
          idx = posName >= 0 ? posName : 0;
        }
      }

      // 🎯 特例：「しらふじ」だけ常に index = 5 に固定
      if (label === 'しらふじ') {
        idx = 5;
      }

      // ---- JANの8桁目だけ置き換え ----
      // 例：3237105083833 → 3237105{idx}83833
      const newJan = jan.slice(0, 7) + String(idx) + jan.slice(8);

      // ---- 新しい画像URLを作成 ----
      const newURL = `https://tkdeko.com/cdn/shop/files/${newJan}_01_a.jpg`;

      // ---- 商品画像を探して切り替え ----
      let img =
        document.querySelector('.media__image img') ||
        document.querySelector('.product__media img') ||
        document.querySelector('[data-media-id] img') ||
        document.querySelector('img[src*="/files/"]');

      if (!img) {
        console.warn("⚠️ 画像タグが見つかりません。セレクタを確認してください。");
        return;
      }

      // lazyload対策（Shopify Dawn特有）
      img.removeAttribute('srcset');
      img.removeAttribute('data-src');
      img.removeAttribute('data-widths');
      img.removeAttribute('sizes');

      // ---- 切り替え実行 ----
      img.src = newURL;
      img.srcset = newURL;

      console.log('✅ 画像を変更しました:', { idx, label, newJan, newURL });
    } catch (err) {
      console.error("❌ setColor 実行エラー:", err);
    }
  };
});
